import api from './../index'

const deleteMessage = (messageId: number) => {
  return api.delete(`/home/messages/${messageId}`)
}

export default deleteMessage
